import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m3.541 6.46.92-.919L8 9.081l3.54-3.54.92.92L8 10.92 3.54 6.46Z"
      fill="var(--main-color)"
    />
  </svg>
);

export default SvgComponent;
